import {useEditorContext} from '../../providers/editor-context';
import {YWCAS_RESULTS_VIEW_STORE_KEY} from '../../../data';
import {useRef} from '@wordpress/element';
import {useSelect} from '@wordpress/data';
import fastDeepEqual from 'fast-deep-equal/es6';
import {YWCAS_DEFAULT_QUERY} from "../../../config";


const cache = {};
export const useStoreSearch = (options = {
    query: '',
    showCategories: false,
    maxResults: 5
}) => {
    const currentResults = useRef({});
    const {isEditor} = useEditorContext();
    const {
        query,
        showCategories,
        maxResults
    } = options;
    const searchQuery = isEditor ? YWCAS_DEFAULT_QUERY : query;
    const results = useSelect((select) => {
        if (cache[searchQuery]) {
            return {
                results: cache[searchQuery],
                isSearching: false,
            }
        } else {
            const store = select(YWCAS_RESULTS_VIEW_STORE_KEY);
            const searchResults = store.getSearchedResults(searchQuery, 0, showCategories, maxResults, isEditor);
            const isSearching = !store.hasFinishedResolution('getSearchedResults', [searchQuery, 0, showCategories, maxResults, isEditor]);
            const data = {
                results: searchResults,
                isSearching,
            };
            if (!isSearching) {
                cache[query] = searchResults;
            }
            return data;
        }
    }, [query]);
    if (
        !currentResults.current ||
        !fastDeepEqual(currentResults.current, results)
    ) {
        currentResults.current = results;
    }

    const getCategories = type => useSelect((select) => {
        const store = select(YWCAS_RESULTS_VIEW_STORE_KEY);
        return {
            categories: store.getCategories(type),
            isLoading: !store.hasFinishedResolution('getCategories', [type])

        };
    }, [type]);


    const getResults = (query = false)=> useSelect((select) =>{
        const store = select(YWCAS_RESULTS_VIEW_STORE_KEY);
        const results = store.getResults();
        return {
            results:  query && cache[query] ? cache[query] : results,
            isLoading: store.getLastQuery() === ''
        };
    },[query]);

    return {
        results: currentResults.current.results,
        isSearching: currentResults.current.isSearching,
        getCategories,
        getResults
    };
};